export default "__VITE_ASSET__CSxz7MCG__"